import React from "react";
import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link } from "react-router-dom";
const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div
      className=""
      style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.329)" }}
    >
      <div className="container">
        <div className="header">
          <Link to={"/"}>
          <img src="/assets/images/logo.png" alt="" />

          </Link>
          <div>
            <Link to={"/"}>Home</Link>

            <a href="">Features</a>

            <a href="">How it works</a>

            <a href="">Contact</a>
          </div>
          <Link to={"/register"}>
            <button className="bg-btn">
              Join Beta{" "}
              <img src="/assets/images/rightarrow.svg" alt="rightarrow" />
            </button>
          </Link>
        </div>
        <div className="mobile-header">
          <div className="d-flex align-items-center justify-content-between">
            <Link to={"/"}>
            <img src="/assets/images/logo.png" alt="" />

            </Link>
            <div onClick={handleShow} style={{ cursor: "pointer" }}>
              <img
                style={{ width: "32px" }}
                src="/assets/images/Menu.svg"
                alt="Menu"
              />
            </div>
          </div>

          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
<img src="/assets/images/logo.png" alt="" />

              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul>
                <li>
                  <a href="">Home</a>
                </li>
                <li>
                  <a href="">Features</a>
                </li>
                <li>
                  <a href="">How it works</a>
                </li>
                <li>
                  <a href="">Contact</a>
                </li>
                <li>
                  <Link to={"/register"}>
                    <button className="bg-btn">
                      Join Beta{" "}
                      <img
                        src="/assets/images/rightarrow.svg"
                        alt="rightarrow"
                      />
                    </button>
                  </Link>
                </li>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  );
};

export default Header;
